import React, { useState } from 'react'
import SubjectManagement from './components/subject-config-table'
import JobTable from './components/job-data-table'
import ConfigurationListTable from './components/configuration-table'
const SystemEmailJobManagement = () => {

  const [isRefetchList, setIsRefetchList] = useState(true)
  return (
    <div className="px-20 py-10 md:px-10">
      <JobTable isRefetchList={isRefetchList} setIsRefetchList={setIsRefetchList} />
      <hr className="my-10 border-t-neutral-6" />
      <SubjectManagement />
      <hr className="my-10 border-t-neutral-6" />
      <ConfigurationListTable tableName="Banned List Setting" type="AVOID_SETTING" />
      <hr className="my-10 border-t-neutral-6" />
      <ConfigurationListTable tableName="T-Day Setting" type="DATE_SETTING" />
    </div>
  )
}

export default SystemEmailJobManagement
